import { defineStore } from 'pinia';

let toastIdCounter = 0;

export const useToastStore = defineStore('toast', {
  state: () => ({
    toasts: []
  }),

  actions: {
    add({ title, message = '', type = 'info', duration = 5000 }) {
      const id = ++toastIdCounter;
      const toast = {
        id,
        title,
        message,
        type,
        duration,
        progress: 100
      };

      this.toasts.push(toast);

      if (duration > 0) {
        // Animate progress bar
        const interval = 50;
        const steps = duration / interval;
        const decrement = 100 / steps;
        
        let currentProgress = 100;
        const progressInterval = setInterval(() => {
          currentProgress -= decrement;
          const toastIndex = this.toasts.findIndex(t => t.id === id);
          if (toastIndex !== -1) {
            this.toasts[toastIndex].progress = Math.max(0, currentProgress);
          }
        }, interval);

        // Auto remove after duration
        setTimeout(() => {
          clearInterval(progressInterval);
          this.remove(id);
        }, duration);
      }

      return id;
    },

    remove(id) {
      const index = this.toasts.findIndex(t => t.id === id);
      if (index !== -1) {
        this.toasts.splice(index, 1);
      }
    },

    success(title, message = '') {
      return this.add({ title, message, type: 'success' });
    },

    error(title, message = '') {
      return this.add({ title, message, type: 'error', duration: 7000 });
    },

    warning(title, message = '') {
      return this.add({ title, message, type: 'warning', duration: 6000 });
    },

    info(title, message = '') {
      return this.add({ title, message, type: 'info' });
    },

    clear() {
      this.toasts = [];
    }
  }
});
